import {
  GiAlmond,
  GiBeet,
  GiBroccoli,
  GiCarrot,
  GiCherry,
  GiChiliPepper,
  GiGarlic,
  GiGrapes,
  GiGrass,
  GiHighGrass,
  GiKiwiFruit,
  GiOlive,
  GiOrange,
  GiPeach,
  GiPeanut,
  GiPear,
  GiPotato,
  GiPumpkin,
  GiShinyApple,
  GiSpring,
  GiStrawberry,
  GiTomato,
  GiWatermelon,
  GiWheat,
} from "react-icons/gi";

export const cropTypeNameToIcon: Record<string, React.ElementType> = {
  Apple: GiShinyApple,
  Grass: GiHighGrass,
  "Turfgrass (cool season)": GiHighGrass,
  "Turfgrass (warm season)": GiHighGrass,
  Grapes: GiGrapes,
  "Table Grape": GiGrapes,
  "Wine Grape": GiGrapes,
  Carrot: GiCarrot,
  Olive: GiOlive,
  Cherry: GiCherry,
  Plum: GiCherry,
  Apricot: GiPeach,
  Lettuce: GiBroccoli,
  Groundnut: GiPeanut,
  Citrus: GiOrange,
  Almond: GiAlmond,
  Pistachio: GiAlmond,
  Walnut: GiAlmond,
  Garlic: GiGarlic,
  Peach: GiPeach,
  Pear: GiPear,
  Onion: GiGarlic,
  "Spring Onions": GiSpring,
  Potato: GiPotato,
  Strawberry: GiStrawberry,
  Spinach: GiBroccoli,
  Celery: GiGrass,
  "Sweet Pepper": GiChiliPepper,
  Tomato: GiTomato,
  Cucumber: GiGrass,
  Zucchini: GiGrass,
  Eggplant: GiGrass,
  Cauliflower: GiBroccoli,
  Cabbage: GiBroccoli,
  Radish: GiCarrot,
  Beetroot: GiBeet,
  Parsnip: GiCarrot,
  Pumpkin: GiPumpkin,
  "Winter Squash": GiPumpkin,
  Watermelon: GiWatermelon,
  "Green Beans": GiGrass,
  "Peas (fresh)": GiGrass,
  Kiwi: GiKiwiFruit,
  "Alfalfa (hay)": GiGrass,
  "Maize (grain)": GiWheat,
  Wheat: GiWheat,
  Barley: GiWheat,
  Rapeseed: GiGrass,
};

export const cropTypeToIcon: Record<number, React.ElementType> = {
  1: cropTypeNameToIcon.Apple,
  2: cropTypeNameToIcon["Turfgrass (cool season)"],
  3: cropTypeNameToIcon["Alfalfa (hay)"],
  4: cropTypeNameToIcon.Almond,
  5: cropTypeNameToIcon.Citrus,
  6: cropTypeNameToIcon.Groundnut,
  7: cropTypeNameToIcon.Lettuce,
  8: cropTypeNameToIcon.Olive,
  9: cropTypeNameToIcon["Wine Grape"],
  10: cropTypeNameToIcon["Table Grape"],
  11: cropTypeNameToIcon.Carrot,
};

export function getCropTypeIcon(cropTypeId?: number | null, cropTypeName?: string | null) {
  if (cropTypeId != null) {
    const cropTypeIcon = cropTypeToIcon[cropTypeId];
    if (cropTypeIcon) {
      return cropTypeIcon;
    }
  }

  if (cropTypeName) {
    return cropTypeNameToIcon[cropTypeName];
  }

  return undefined;
}
